import React from 'react';

import { DateTime } from '@/widgets';
import { IMessageData } from '@/types';

import styles from './NotificationWidget.module.scss';
import { useNotificationsWidget } from './useNotificationsWidget';
import NotificationBell from './NotificationBell';
import NotificationsDrawer from './NotificationsDrawer';

interface INotificationsWidgetProps {
	showNotificationIcon?: boolean;
}

export function toastTemplate(messages: IMessageData[]) {
	if (messages?.length > 1) {
		return (
			<div
				className={styles.notificationToast}
			>{`You have ${messages?.length} new messages`}</div>
		);
	}

	if (messages?.length === 1) {
		const messageData = messages[0];
		return (
			<div className={styles.notificationToast}>
				<div className={styles.title}>{messageData.title}</div>
				<div className={styles.message}>{messageData.subTitle}</div>
				<div className={styles.message}>{messageData.message}</div>
				<DateTime className={styles.date} format="MMM DD, YYYY hh:mm A">
					{messageData.date}
				</DateTime>
			</div>
		);
	}
	return null;
}

/**
 *
 * @description Widget for handling view and interactions of notifications
 *
 * @author  Rohit Niraj Singh <@rohit.singh3>
 *
 * @returns {React.ReactElement}
 */

export default function NotificationsWidget({
	showNotificationIcon = true,
}: Readonly<INotificationsWidgetProps>) {
	const {
		handleNotificationDrawerClose,
		unreadNotificationCount,
		notificationEnabled,
		handleBellClick,
		notifications,
		showNotificationsDrawer,
	} = useNotificationsWidget({
		toastTemplate,
		showNotificationIcon,
	});

	if (notificationEnabled) {
		return (
			<>
				<NotificationBell
					onBellClick={handleBellClick}
					unreadNotificationCount={unreadNotificationCount}
				/>

				<NotificationsDrawer
					isOpen={showNotificationsDrawer}
					handleDrawerClose={handleNotificationDrawerClose}
					notifications={notifications}
				/>
			</>
		);
	}
	return null;
}
